let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ii6TT")).then(() => parcelRequire('hru40'));